import { REACT_QUERY_KEYS, bridgeRequest } from 'common'
import { Purposes } from 'common/types'
import { TEndpoint, TEntity, TUserType } from 'contexts/app-context/types'
import { entityPayloadMap } from 'contexts/app-context/types/app-context/components/utils'

import { queryOptions } from '@tanstack/react-query'

interface GetPurposesQueryParams {
  endpoint?: TEndpoint
  userCountry?: string
  userSelectedEntity?: TEntity
  userAccountType?: TUserType
  isUSBranch: boolean
}

export const getPurposesQueryKey = ({
  userCountry,
  userSelectedEntity,
  userAccountType,
}: Pick<GetPurposesQueryParams, 'userCountry' | 'userSelectedEntity' | 'userAccountType'>) => [
  REACT_QUERY_KEYS.PURPOSES,
  userCountry,
  userSelectedEntity,
  userAccountType,
]

export const getPurposesQueryOptions = ({
  endpoint,
  userCountry,
  userSelectedEntity,
  userAccountType,
  isUSBranch,
}: GetPurposesQueryParams) =>
  queryOptions({
    queryKey: getPurposesQueryKey({ userCountry, userSelectedEntity, userAccountType }),
    queryFn: () => {
      const customHeaders = userCountry &&
        userSelectedEntity && {
          'x-inter-user-org': userCountry,
          'x-inter-account-org': entityPayloadMap[userSelectedEntity],
        }

      if (!endpoint) throw new Error('No get purposes endpoint available')

      return bridgeRequest<Purposes>({
        endpoint: {
          ...endpoint,
          headers: { ...endpoint.headers, ...customHeaders },
        },
        returnAllResponse: false,
        isUSBranch,
      })
    },
    enabled: !isUSBranch && !!endpoint && !!userCountry && !!userSelectedEntity,
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 6,
  })
